module.exports = __webpack_public_path__ + "img/ledger.283e5e28.jpg";